/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import checkout from "./form";

const {
  formField: {
    name,
    last_name,
    mother_last_name,
    email,
    phone,
    comments
  },
} = checkout;

const initialValues = {
  [name.name]: "",
  [last_name.name]: "",
  [mother_last_name.name]: "",
  [email.name]: "",
  [phone.name]: "",
  [comments.name]: ""
};

export default initialValues;
